import 'core-js/fn/array/includes';

import { createAction, handleActions } from 'redux-actions';
import { Record, Map, List } from 'immutable';
import QueryString from 'query-string';
import { pender } from 'redux-pender';

import { camelizeObjKeys } from '~/utils/CamelizeUtils.js';
import { format } from '~/utils/FormatUtils.js';
import constants from '~/constants.js';
import history from '~/history.js';
import * as api from '~/lib/api';

const SELECT_SECTION = 'agents/SELECT_SECTION';
const SELECT_DIVISION = 'agents/SELECT_DIVISION';
const SELECT_KIC = 'agents/SELECT_KIC';
const CHANGE_SEARCH_FILTER = 'agents/CHANGE_SEARCH_FILTER';
const GET_NUM_AGENTS = 'agents/GET_NUM_AGENTS';
const GET_AGENTS = 'agents/GET_AGENTS';
const GET_NEXT_AGENTS = 'agents/GET_NEXT_AGENTS';

export const selectSection = createAction(SELECT_SECTION, section => section);
export const selectDivision = createAction(
  SELECT_DIVISION,
  division => division
);
export const selectKic = createAction(SELECT_KIC, kic => kic);
export const changeSearchFilter = createAction(CHANGE_SEARCH_FILTER);
export const getNumAgents = createAction(GET_NUM_AGENTS, api.getNumAgents);
export const getAgents = createAction(GET_AGENTS, params =>
  api.getAgentsList(params)
);
export const getNextAgents = createAction(GET_NEXT_AGENTS, params =>
  api.getAgentsList(params)
);

const initialState = Record({
  section: '',
  sectionName: '',
  sectionType: '',
  division: '',
  kic: '',
  numAgents: 4255,
  agents: List(),
  currentPage: 1,
  totalPages: 1,
  error: null,
})();

const Agent = Record({
  id: 0,
  name: '',
  address: '',
  phoneNumber: '',
  clients: '',
  views: '',
  calls: '',
  tags: [],
  favored: false,
  reviews: '',
  overallRatings: 0,
});

function _preprocessAgents(list, arr) {
  for (const agent of arr) {
    list = list.push(
      Agent({
        ...agent,
        clients: format(agent.clients),
        views: format(agent.views, 'kr'),
        calls: format(agent.calls, 'kr'),
        favored: agent.clients >= constants.numClientsForFavoredLabel,
        reviews: format(agent.reviews, 'kr'),
        overallRatings: agent.ratings.overall,
      })
    );
  }

  return list;
}

export default handleActions(
  {
    [SELECT_SECTION]: (state, { payload: section }) => {
      const matched = constants.sections[section];
      if (!section || !matched) {
        return state;
      }

      return state.merge(
        Map({
          section: section,
          sectionName: matched.name,
          sectionType: matched.type,
          division: '',
          error: null,
        })
      );
    },
    [SELECT_DIVISION]: (state, { payload: division }) => {
      const section = state.section;
      const matched = constants.divisions[section];
      if (
        !division ||
        !(division === 'all' || (matched && matched.includes(division)))
      ) {
        return state;
      }

      return state.set('division', division);
    },
    [SELECT_KIC]: (state, { payload: kic }) => {
      if (!kic || !(kic === 'all' || constants.kics.includes(kic))) {
        return state;
      }

      return state.set('kic', kic);
    },
    [CHANGE_SEARCH_FILTER]: state => {
      const { section, division, kic } = state;
      if (section === '') {
        return state.set('error', '지역을 선택해주세요.');
      } else {
        const searchQuery = QueryString.stringify({
          section,
          division:
            division !== '' && division !== 'all' ? division : undefined,
          kic: kic !== '' && kic !== 'all' ? kic : undefined,
        });
        history.push({
          pathname: '/agents',
          search: `?${searchQuery}`,
        });
        return state;
      }
    },
    ...pender({
      type: GET_NUM_AGENTS,
      onSuccess: (state, { payload: response }) => {
        return state.merge(Map({ numAgents: response.data }));
      },
    }),
    ...pender({
      type: GET_AGENTS,
      onSuccess: (state, { payload: response }) => {
        const data = camelizeObjKeys(response.data);
        let list = List();
        return state.merge(
          Map({
            currentPage: data.currentPage,
            totalPages: data.totalPages,
            agents: _preprocessAgents(list, data.agents),
          })
        );
      },
    }),
    ...pender({
      type: GET_NEXT_AGENTS,
      onSuccess: (state, { payload: response }) => {
        const data = camelizeObjKeys(response.data);
        let list = state.agents;
        return state.merge(
          Map({
            currentPage: data.currentPage,
            totalPages: data.totalPages,
            agents: _preprocessAgents(list, data.agents),
          })
        );
      },
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/store/modules/agents.js